import React from 'react';

import clsx from 'clsx';

export type ButtonSize = 'icon' | 'small' | 'large' | 'wide';

export type ButtonWrapperProps = {
  children?: React.ReactNode;
  onClick?: () => void;
  onMouseLeave?: () => void;
  disabled?: boolean;
  size?: ButtonSize;
  type?: 'submit' | 'button' | 'reset';
  id?: string;
  dataTestId?: string;
};

const TenantThemeButton = ({
  children,
  onClick,
  onMouseLeave,
  disabled,
  size = 'small',
  type = 'button',
  id = 'id',
  dataTestId,
}: ButtonWrapperProps) => {
  const classStack = clsx(
    'rounded-md bg-[var(--themePrimaryButtonColor)] text-base font-medium text-[var(--themePrimaryButtonTextColor)] sm:block',
    disabled ? 'cursor-not-allowed opacity-70' : 'cursor-pointer',
    size === 'small' ? 'min-h-[34px] px-2.5 py-1.5' : '',
    size === 'wide' ? 'min-h-[48px] w-full  px-8 py-3' : '',
  );

  return (
    <button
      id={id}
      data-testid={dataTestId}
      className={classStack}
      disabled={disabled}
      aria-busy={disabled}
      aria-disabled={disabled}
      type={type}
      onClick={onClick}
      onMouseLeave={onMouseLeave}
    >
      <span className="flex items-center justify-center h-full">{children}</span>
    </button>
  );
};

export default TenantThemeButton;
